





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { getEntityPage, navigateTo, replaceTab } from '@/common/RouteUtils';
import RouteTab from '@/components/RouteTab.vue';
import FuelTankFaultChart from '@/components/charts/fuel-tank-fault-chart.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import {
	Org,
	OrgsApi,
	ProductsApi,
	ProductType,
	SimproJobDetails,
	Transceiver,
	User,
	Tank,
	Vat,
} from '@/api';
import ErrorDiv from '@/components/display/errorDiv.vue';
import SimPro from '@/components/tables/simPro.vue';
import Toast from '@/components/display/toast.vue';
import VatDisplay from '@/components/vat-display.vue';
import TankView from '@/pages/account/products/fuel/tanks/view.vue';
import { email, minLength, numeric, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import TitleMixin from '@/mixins/title-mixin';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import UsersTable from '@/components/tables/users-table.vue';
import AddJob from '@/components/add business objects/addJob.vue';
import OldAddJob from '@/components/add business objects/oldAddJob.vue';
import VatCurrentStatus from '@/components/charts/vat-currentStatus.vue';
import TankCurrentStatus from '@/components/charts/tank-currentStatus.vue';
import addFault from '@/components/add business objects/addFault.vue';
import AdminChart from '@/components/charts/admin-chart.vue';
import { sortFuelTanks } from '@/common/FormattingUtils';

import FeedTankFaultDisplay from './components/FeedTankFaultDisplay.vue';
import { getProductAllowedUserIds } from '@/services/user-service';
import AddJobModalsContainer from '@/components/add business objects/add-job/AddJobModalsContainer.vue';
import TreeView from '@/components/display/tree.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import RawData from '@/components/display/raw-data/raw-data.vue';

@Component({
	components: {
		RouteTab,
		ChangelogLink,
		AddJobModalsContainer,
		addFault,
		ErrorDiv,
		VatDisplay,
		TankView,
		OldAddJob,
		secondaryNav,
		Toast,
		RawData,
		SimPro,
		AdminChart,
		routerLinkButton,
		infoTabs,
		UsersTable,
		AddJob,
		VatCurrentStatus,
		TankCurrentStatus,
		FeedTankFaultDisplay,
		TreeView,
		FuelTankFaultChart,
	},
	validations: {
		jobForm: {
			type: { required, minLength: minLength(1) },
			notes: { required, minLength: minLength(1) },
			status: { required, minLength: minLength(1) },
		},
	},
	methods: {
		sortFuelTanks,
	},
	mixins: [validationMixin, TitleMixin],
})
export default class ProductView extends Vue {
	public componentKey = 0;
	public loading = true;
	public product: any | null = null;
	public allowedUserIds: number[] | null = null;
	public org: any | null = null;
	public transceiver: any | null = null;
	public faultError: string | null = null;
	public faults = {};
	public selectedCurrent = [];
	public selectedPast = [];
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public jobModal = false;
	public get currentPage(): number {
		return getEntityPage(this.$route, this.product?.tanks || [], 'faults.tanks', 'tankId');
	}

	public set currentPage(page: number) {
		if (!this.$route.name?.startsWith('faults.tanks.') || page === this.currentPage) return;
		const tank: Tank | undefined = this.product.tanks[page - 2];
		navigateTo(this.$router, {
			name: tank ? 'faults.tanks.detail.general.information' : 'faults.tanks.overview',
			params: {
				productId: this.$route.params.productId,
				...(tank ? { tankId: String(tank.id) } : {}),
			},
		});
	}

	public get firstTransceiver(): Transceiver | undefined {
		return this.product.type === ProductType.Fuel
			? this.product.tanks.find((tank: Tank) => tank.transceiver)?.transceiver
			: this.transceivers[0];
	}

	@Watch('$route', { immediate: true })
	@Watch('product')
	public ensureAvailableTab(): void {
		if (!this.product || String(this.product.id) !== String(this.$route.params.productId)) return;
		const name = this.$route.name || '';
		let fallback: string | undefined;
		if (name.startsWith('faults.tanks.')) {
			if (this.product.type !== ProductType.Fuel) fallback = 'faults.general';
			else if (name.startsWith('faults.tanks.detail.') && this.currentPage === 1) {
				fallback = 'faults.tanks.overview';
			}
		} else if (name === 'faults.vats' || name.startsWith('faults.vats.')) {
			if (
				this.product.type !== ProductType.Milk ||
				(name.startsWith('faults.vats.detail.') &&
					!this.product.vats.some(
						(vat: Vat) => String(vat.id) === String(this.$route.params.vatId),
					))
			)
				fallback = 'faults.general';
		} else if (name.startsWith('faults.transceivers.detail.')) {
			const transceivers =
				this.product.type === ProductType.Fuel
					? this.getUniqueTransceivers(this.product.tanks)
					: this.transceivers;
			if (
				!transceivers.some(
					transceiver => String(transceiver.id) === String(this.$route.params.transceiverId),
				)
			) {
				fallback = 'faults.general';
			}
		}
		if (fallback) replaceTab(this.$router, fallback);
	}
	private readonly perPage = 1;
	public currentPageFaults = { current: 1, past: 1 };
	public perPageFaults = { current: 22, past: 22 };
	public totalRowsFaults = { current: 0, past: 0 };
	public dash = [];
	public dataModal = { show: false, json: {} };
	public renderKey = 0;
	public simproJobs: SimproJobDetails[] = [];
	public simproTabVisited = false;

	public partnerOrgs: Org[] = [];

	public vatChangeLogFields = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];
	public faultLogFields = [
		{ key: 'type', label: 'Type' },
		{ key: 'message', label: 'Fault Message', class: 'fault-col' },
		{ key: 'createdAt', label: 'Created At', sortable: true },
		{ key: 'data', label: 'Raw Data' },
	];
	public activityLogFields = [
		{ key: 'logName', label: 'Log Name' },
		{ key: 'user.name', label: 'User' },
		{ key: 'createdAt', label: 'created At', sortable: true },
	];

	public tanksFields: any[] = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{ key: 'status', label: 'Status' },
		{ key: 'transceiver.serialNumber', label: 'Transceiver' },
		{ key: 'sensor.serialNumber', label: 'Sensor' },
	];
	public urls = {
		PowerOutage: require('../../../assets/svgs/faults/BatteryLow.svg'),
		BatteryLow: require('../../../assets/svgs/faults/BatteryLow.svg'),
		MissingSensorData: require('../../../assets/svgs/faults/MissingSensorData.svg'),
		MissingTransceiverData: require('../../../assets/svgs/faults/MissingSensorData.svg'),
		MultipleReboots: require('../../../assets/svgs/faults/rebooted.svg'),
		SensorAllocation: require('../../../assets/svgs/faults/Sensor.svg'),
	};

	public transceiverId: any[] | null = null;
	public actModal = false;
	public form = { notes: '' };
	public faultsList: any[] = [];
	private api: ProductsApi = new ProductsApi();

	public checkInTime = null;

	get uniqueTransceivers(): [] {
		return this.product.tanks.filter(
			(tank, index, array) =>
				tank.transceiverId !== null &&
				array.findIndex(t => t.transceiverId === tank.transceiverId) === index,
		);
	}

	public newFault(e: Event) {
		this.load();
	}

	public modalShow(item: any) {
		this.dataModal = { json: item, show: !this.dataModal.show };
		// this re renders the modal
		this.renderKey = this.renderKey > 0 ? -1 : 1;
	}

	public forceRerender() {
		this.componentKey += 1;
	}

	public selectAllRows() {
		this.$refs.selectableTable.selectAllRows();
	}

	public clearSelected() {
		this.$refs.selectableTable.clearSelected();
	}

	public getPaginationListItem(page) {
		return [{ name: 'Overview' }].concat(this.product.tanks)[page - 1];
	}

	public rowClickHandler(item: Tank) {
		this.currentPage = this.product.tanks.findIndex((tank: Tank) => tank.id === item.id) + 2;
	}

	public onRowSelected(items: [], table: string) {
		if (table === 'current') {
			this.selectedCurrent = items;
			this.totalRowsFaults.current = items
				.flatMap(x => {
					return x.faultlogs;
				})
				.filter(y => y != null).length;
		} else if (table === 'past') {
			this.selectedPast = items;
			this.totalRowsFaults.past = items
				.flatMap(x => {
					return x.faultlogs;
				})
				.filter(y => y != null).length;
		}
	}

	public onFilteredCurrent(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRowsFaults.current = filteredItems.length;
		this.currentPageFaults.current = 1;
	}

	public onFilteredPast(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRowsFaults.past = filteredItems.length;
		this.currentPageFaults.past = 1;
	}

	public pageTitle() {
		return `Fault | ${
			this.product
				? this.product.type === 'milk'
					? this.product.supplierNumber
					: `id: ${this.product.id}`
				: ''
		}`;
	}

	public async load() {
		const { productId } = this.$route.params;
		// this.loading = true;
		try {
			const { data } = await this.api.getProductById(parseInt(productId, 10), {
				params: {
					include:
						'users,site,tanks.transceiver,transceivers,' +
						'tanks.sensor,faults,vats.audits,vats.transceiver,' +
						'vats.sensors,faults.fault_logs,faults.owner,vats.audits.user,' +
						'activity_logs,activity_logs.user,waterMeters,waterTanks,waterMonitors,' +
						'waterMeters.sensor,waterTanks.sensor,waterMonitors.sensor,' +
						'waterMeters.transceiver,waterTanks.transceiver,waterMonitors.transceiver,' +
						'feedtanks,feedtanks.transceiver,feedtanks.sensor,',
				},
			});
			this.product = data;
			this.product.tanks = sortFuelTanks(this.product.tanks);
			this.org = { id: this.product.orgId } || {};
			const faultNameList: any[] = [];
			const faults: any[] = [];
			data.faults.forEach(
				(fault: {
					status: string;
					faultlogs: Array<{ createdAt: number }>;
					ownerName: string;
					name: any;
				}) => {
					if (['resolved', 'active', 'monitor', 'rebooting', 'repair'].includes(fault.status)) {
						// sort by fault log
						fault.faultlogs.sort((a: { createdAt: number }, b: { createdAt: number }) =>
							a.createdAt < b.createdAt ? -1 : 1,
						);
						fault.ownerName = this.getFaultOn(fault);
						faults.push(fault);
						faultNameList.push(
							`${fault.name || ''} on ${this.getFaultOn(fault)} (${fault.status})`,
						);
					}
				},
			);
			this.faultsList = faultNameList;
			this.faults = faults.sort(
				(a: { updatedAt: string }, b: { updatedAt: string }) =>
					new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
			);
			this.allowedUserIds = await getProductAllowedUserIds(productId);
		} catch (e) {
			console.log(e);
			this.product = null;
			this.faultError = e.toString();

			if (e.response && e.response.data && e.response.data.message) {
				this.faultError = e.response.data.message;
				console.log(this.faultError);
			}
		} finally {
			this.loading = false;
		}
	}

	public async loadUsers() {
		const { productId } = this.$route.params;
		const { data } = await this.api.getProductById(parseInt(productId, 10), {
			params: { include: 'users' },
		});
		this.users = data.users || [];
		this.users.forEach((user: { id: any }) => {
			this.form.users.push(Object.assign({ checked: false, sms: false, id: user.id }, user));
		});
	}

	public async loadAct() {
		const { productId } = this.$route.params;
		const action = this.form.notes;
		try {
			const response = await new ProductsApi().productFaultsActivity(
				parseInt(this.product.id, 10),
				{ data: { action } },
			);
		} catch (e) {
			const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Creating Activity Log', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Activity Logged', 'Log Created', 'success');
		this.load();
	}

	public async activity(action: string) {
		try {
			const response = await new ProductsApi().productFaults(parseInt(this.product.id, 10), {
				data: { action },
			});
			new Toast().makeToast(
				`Product fault status has been set to ${action}`,
				'fault status',
				'success',
				false,
			);
			this.$router.push({ name: 'faults.list' });
		} catch (e) {
			console.log(e);
			new Toast().makeToast(
				`Product fault status has not been set to ${action}`,
				'fault status',
				'danger',
				true,
			);
		}
	}

	public async created() {
		await this.load();
		this.loadDash();
		await this.loadPartners();
	}

	public async loadDash() {
		const { productId } = this.$route.params;
		if (this.product.type === 'milk') {
			const api = new ProductsApi();
			try {
				const response = await api.getProductDash(parseInt(productId, 10));
				this.dash = response.data.data;
			} catch (e) {
				this.faultError = e.toString();
				if (e.response && e.response.data && e.response.data.message) {
					this.faultError = e.response.data.message;
				}
			}
		}
	}

	public async loadPartners() {
		const { productId } = this.$route.params;
		try {
			const data = await new ProductsApi().getProductPartnerOrgs(parseInt(productId, 10));
			this.partnerOrgs = (data.data.data ?? []).filter(p => p !== null);
		} catch (e) {
			this.partnerOrgs = [];
			console.log('Error loading partner orgs:', e);
		}
	}

	public getUrl(type: string) {
		return this.urls[type];
	}

	public getFaultOn(fault: any) {
		return `${fault.ownerType}: ${fault.owner.name ||
			fault.owner.serialNumber ||
			this.product.name}`;
	}

	private getUniqueTransceivers(entities: any[]): Transceiver[] {
		return entities
			.filter(entity => entity.transceiver)
			.map(entity => entity.transceiver)
			.filter((t, index, array) => array.findIndex(other => other.id === t.id) === index);
	}

	private get transceivers(): Transceiver[] {
		switch (this.product.type) {
			case ProductType.Milk:
				return this.product.transceivers;
			case ProductType.Water:
				return this.getUniqueTransceivers([
					...this.product.watermeters,
					...this.product.watertanks,
					...this.product.watermonitors,
				]);
			case ProductType.Feed:
				return this.getUniqueTransceivers(this.product.feedtanks);
		}
		return [];
	}

	public simproJobsLoaded(simproJobs: SimproJobDetails[]) {
		this.simproJobs = simproJobs;
	}
}
